import * as React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

export default function Variants() {
  return (
    <Stack spacing={1}>
      {/* For variant="text", adjust the height via font-size */}
      <Skeleton variant="text" sx={{ fontSize: "0.5rem" }} />
    </Stack>
  );
}

export const ChartLoader = () => {
  return (
    <Stack spacing={2} sx={{ width: "90%", height: "385px", padding: "16px" }}>
      {/* Main chart area skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height="100%"
        animation="wave"
        sx={{
          transform: "none", // Prevents default MUI scaling animation
          backgroundColor: "#f5f5f5", // Light gray background
        }}
      />

      {/* Legend items skeletons */}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          marginTop: "8px",
          justifyContent: "center",
        }}
      >
        <Skeleton variant="rounded" width={500} height={40} animation="wave" />
      </Stack>
    </Stack>
  );
};
